import React, { useMemo } from 'react';

import { Grid, IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import { LoadingPage, RecordContextProvider, useRedirect } from 'react-admin';

import { useParams } from 'react-router-dom';

import useEntityData from '../../../../../../hooks/useEntityData';

import { AdverseMediaMatches } from '../../../../../../utilities/schemas/adverseMediaMatches';

import actions from '../../../../../../constants/actions';

import AdverseMediaMatchInformation from '../../../../../individual/editTabs/kyc/adverseMedia/details/AdverseMediaMatchInformation';
import AdverseMediaNationalIdentifiers from '../../../../../individual/editTabs/kyc/adverseMedia/details/AdverseMediaNationalIdentifiers';
import AdverseMediaImages from '../../../../../individual/editTabs/kyc/adverseMedia/details/AdverseMediaImages';
import AdverseMediaSources from '../../../../../individual/editTabs/kyc/adverseMedia/details/AdverseMediaSources';
import AdverseMediaRelatedEntities from '../../../../../individual/editTabs/kyc/adverseMedia/details/AdverseMediaRelatedEntities';
import AdverseMediaMedias from '../../../../../individual/editTabs/kyc/adverseMedia/details/AdverseMediaMedias';
import AdverseMediaAboutBusiness from './AdverseMediaAboutBusiness';

const GoBackButton = () => {
  const redirect = useRedirect();

  return (
    <IconButton onClick={() => { redirect('..'); }} size="small">
      <ArrowBackIosIcon color="inherit" fontSize="medium" />
    </IconButton>
  );
};

const AdverseMediaDetails = () => {
  const {
    data,
    isLoading,
  } = useEntityData<AdverseMediaMatches>({
    source: 'adverse-media',
    getAction: actions.INDIVIDUAL_GET_ADVERSE_MEDIA,
  });

  const { adverseMediaId } = useParams();

  const currentSanction = useMemo(
    () => data?.potentialMatches.find((match) => match._id === adverseMediaId),
    [data, adverseMediaId],
  );

  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <RecordContextProvider value={{ ...currentSanction, providerName: data?.providerName }}>
      <Grid container spacing={4}>
        <Grid size={12}>
          <GoBackButton />
        </Grid>
        <Grid size={12}>
          <Grid container spacing={6}>
            <Grid size={12}>
              <AdverseMediaMatchInformation />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Grid container spacing={6}>
                <Grid size={12}>
                  <AdverseMediaAboutBusiness />
                </Grid>
                <Grid size={12}>
                  <AdverseMediaNationalIdentifiers />
                </Grid>
                <Grid size={12}>
                  <AdverseMediaImages />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Grid container spacing={6}>
                <Grid size={12}>
                  <AdverseMediaMedias />
                </Grid>
                <Grid size={12}>
                  <AdverseMediaRelatedEntities />
                </Grid>
              </Grid>
            </Grid>
            <Grid size={12}>
              <AdverseMediaSources />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </RecordContextProvider>
  );
};

export default AdverseMediaDetails;
